import type { FC, PropsWithChildren } from 'react';
import { Suspense } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface IProps {
  text?: string;
}

const SusSidebar: FC<PropsWithChildren<IProps>> = ({
  children,
  text = 'Initialising...',
}) => {
  return (
    <Suspense
      fallback={
        <Box
          sx={{
            backgroundColor: '#ccc',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            width: '100%',
          }}
        >
          <CircularProgress size={80} />
          <Typography sx={{ mt: 2 }}>{text}</Typography>
        </Box>
      }
    >
      {children}
    </Suspense>
  );
};

export default SusSidebar;